import { Flame, Settings, Handshake, Sparkles } from "lucide-react";

const blocks = [
  {
    Icon: Flame,
    num: "01",
    overline: "Especialización",
    title: "Maestría en soldadura MIG/MAG",
    desc: "Nuestro equipo domina la soldadura industrial MIG/MAG aplicada a guardas telescópicas, fuelles metálicos y bastidores de protección. Cada cordón se inspecciona y certifica para garantizar durabilidad bajo ciclos de impacto.",
  },
  {
    Icon: Settings,
    num: "02",
    overline: "Diseño técnico",
    title: "Ingeniería a la medida",
    desc: "Fabricamos cada sistema a partir de las medidas reales de tu centro de maquinado. Diseño asistido por computadora, corte láser de precisión y verificación dimensional para asegurar encaje exacto con la geometría OEM.",
  },
  {
    Icon: Handshake,
    num: "03",
    overline: "Servicio",
    title: "Compromiso de servicio",
    desc: "Respondemos a urgencias de paros de producción y damos seguimiento técnico durante todo el ciclo de vida del producto. Reparación, mantenimiento preventivo y refacciones a medida cuando los necesites.",
  },
  {
    Icon: Sparkles,
    num: "04",
    overline: "Personalización",
    title: "Protección totalmente personalizada",
    desc: "No nos limitamos a soluciones estándar. Adaptamos el diseño de tus guardas y fuelles a las necesidades específicas de tu operación, garantizando durabilidad ante ciclos de impacto y una integración impecable con tu maquinaria.",
  },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative py-24 lg:py-32 bg-[#0A1B35] overflow-hidden"
    >
      <div className="absolute inset-0 gf-grid-bg opacity-40" />
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#00B4D8]/40 to-transparent" />
      <div className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#00B4D8]/40 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14 lg:mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-[#00B4D8]" />
              <span className="gf-overline">Por qué Guarda Flex</span>
            </div>
            <h2 className="font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
              Soluciones inmediatas para que
              <span className="text-[#00B4D8]"> tu producción no se detenga.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-white/70 text-base lg:text-lg leading-relaxed">
              Cuatro pilares que definen cada proyecto que entregamos:
              técnica, ingeniería, compromiso y personalización. Sin atajos,
              sin paros prolongados.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {blocks.map((b, i) => {
            const Icon = b.Icon;
            return (
              <article
                key={b.title}
                data-testid={`value-block-${i}`}
                className="bg-[#0A1B35] p-8 lg:p-9 relative group hover:bg-[#061226] transition-colors"
              >
                <span className="absolute top-4 right-4 font-mono-accent text-xs text-white/30 tracking-widest">
                  {b.num} / 04
                </span>

                <div className="w-14 h-14 border-2 border-[#00B4D8] flex items-center justify-center mb-8 group-hover:bg-[#00B4D8] transition-colors">
                  <Icon size={22} className="text-[#00B4D8] group-hover:text-[#0A1B35] transition-colors" strokeWidth={2} />
                </div>

                <div className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#00B4D8] mb-2">
                  {b.overline}
                </div>
                <h3 className="font-display font-black text-white text-xl lg:text-[22px] tracking-tight leading-tight mb-5">
                  {b.title}
                </h3>
                <p className="text-white/65 text-sm leading-relaxed">
                  {b.desc}
                </p>

                <div className="absolute bottom-0 left-0 h-px w-0 bg-[#00B4D8] group-hover:w-full transition-all duration-700" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
